import SEO from '@/components/SEO';

const ReferralAgreement = () => {
  return (
    <>
      <SEO 
        title="Referral Agreement - SeniorThrive"
        description="SeniorThrive's Certified Age in Place Specialist Referral Program Terms and Conditions."
      />
      
      <div className="min-h-screen bg-gradient-card py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-card rounded-2xl shadow-feature p-8 md:p-12">
            <h1 className="text-4xl font-bold text-foreground mb-8 text-center">
              SeniorThrive Certified Age in Place Specialist Referral Program Terms
            </h1>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-muted-foreground mb-8 text-center text-lg">
                By clicking "I Agree," you confirm your understanding and acceptance of the following terms:
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Eligibility</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You certify that you hold valid Certified Age in Place Specialist credentials or other qualifications approved by SeniorThrive. You agree to keep all certifications, licenses, and insurance current, and to notify SeniorThrive immediately if your status changes.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Independent Relationship</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You acknowledge that you are an independent contractor. No joint venture, partnership, employment, or agency relationship exists between you and SeniorThrive.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Professionalism</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You agree to deliver professional and lawful services, maintain all required licenses and insurance, and treat all SeniorThrive referrals respectfully and fairly.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">No Endorsement or Guarantee</h2>
                <p className="text-muted-foreground leading-relaxed">
                  SeniorThrive does not guarantee any specific number of referrals. Inclusion in our network does not constitute an endorsement, recommendation, or guarantee of any kind. No payment, fee, or commission will be provided to or by SeniorThrive.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Confidentiality and Use of Client Information</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You agree to keep all SeniorThrive referral and client information confidential, to comply with all applicable privacy and data protection laws, and to use such information only for the purpose of providing evaluations or estimates to referred clients. Any other use, including marketing or resale, is strictly prohibited.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Liability</h2>
                <p className="text-muted-foreground leading-relaxed">
                  You are solely responsible for your services, conduct, and outcomes with clients. SeniorThrive is not responsible for, and expressly disclaims liability for, your acts, errors, or omissions. You agree to hold SeniorThrive harmless from any claims, damages, or losses related to your work or interactions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Removal</h2>
                <p className="text-muted-foreground leading-relaxed">
                  SeniorThrive reserves the right to remove you from the network at any time, including in cases of rule violations, expired credentials, or substantiated client complaints.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Program Changes</h2>
                <p className="text-muted-foreground leading-relaxed">
                  SeniorThrive may update these terms at any time. We will notify you of material changes, and continued participation after such notice constitutes your acceptance.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-foreground mb-4">Governing Law</h2>
                <p className="text-muted-foreground leading-relaxed">
                  These terms are governed by the laws of the State of California. Any disputes shall be resolved exclusively in the state or federal courts located in Orange County, California, and you consent to the jurisdiction of those courts.
                </p>
              </section>

              <div className="mt-12 p-6 bg-muted/50 rounded-xl">
                <p className="text-center text-muted-foreground font-medium">
                  By clicking "I Agree," you acknowledge you have read, understood, and agree to these terms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralAgreement;